import {
  Space,
  TextHeading,
  TextBody,
  Box,
  ButtonGroup,
  Button,
  Modal,
  useModalContext,
  Link as MuiLink,
} from '@ally/metronome-ui'
import React from 'react'

const headerRef = React.createRef<HTMLHeadingElement>()
const triggerRef = React.createRef<HTMLButtonElement>()

const LearnMoreFdicButton: React.FC = () => {
  const { setOpen } = useModalContext()

  return (
    <Button
      allytmln="FDIC modal trigger"
      text="Learn more about the FDIC rules."
      variant="link"
      onClick={(): void => setOpen(true)}
      ref={triggerRef}
      data-testid="learn-more-fdic-trigger"
    />
  )
}

const LearnMoreFdicContent: React.FC = () => {
  const { setOpen } = useModalContext()

  const handleClose = (): void => {
    setOpen(false)
    // istanbul ignore next - optional chaining
    triggerRef.current?.focus()
  }

  return (
    <Space mb="md">
      <TextHeading
        tag="h1"
        size="sm"
        weight="bold"
        ref={headerRef}
        tabIndex={-1}
        data-testid="learn-more-fdic-heading"
        id="learn-more-fdic-heading"
        focusOnMount
      >
        This is where we part ways
      </TextHeading>
      <TextBody tag="p" size="md">
        You&apos;re leaving ally.com and heading to a third-party site we
        don&apos;t own or control. FYI: That site has its own privacy policy and
        level of security. We suggest reviewing those policies and any terms and
        conditions on that site. Ready to go?
      </TextBody>
      <Box marginY="md">
        <ButtonGroup>
          <MuiLink
            allytmln="FDIC link button"
            variant="primary"
            text="Continue"
            href="https://www.fdic.gov/resources/deposit-insurance/trust-accounts/index.html"
            target="_blank"
            onClick={handleClose}
          />
          <Button
            allytmln="close FDIC modal"
            text="Go Back"
            onClick={handleClose}
            variant="link"
          />
        </ButtonGroup>
      </Box>
    </Space>
  )
}

export const LearnMoreFdicModal: React.FC = () => {
  return (
    <Modal
      trigger={<LearnMoreFdicButton />}
      content={<LearnMoreFdicContent />}
      fullScreenMd
      width="md"
      disableCloseOnOverlayClick
      onOpenChange={(open): void => {
        if (!open) {
          requestAnimationFrame(() => {
            // istanbul ignore next - Low value test
            triggerRef.current?.focus()
          })
        }
      }}
    />
  )
}
